__turbopack_context__.v({
  "root": "style-module-scss-module__u_GDIa__root",
});
